import { makeStyles } from "tss-react/mui";
import { MiChip } from "@miplatform/components";
import { Box, Typography } from "@mui/material";

interface AssignmentsUserCardProps {
  displayName: string;
  color: string;
  count?: number;
  isSelected?: boolean;
  onClick?: () => void;
}

export const AssignmentsUserCard = ({
  displayName,
  color,
  count = 0,
  isSelected = false,
  onClick,
}: AssignmentsUserCardProps) => {
  const { classes, cx } = useStyles();

  return (
    <Box
      className={cx(classes.root, { [classes.selected]: isSelected })}
      onClick={onClick}
    >
      <Box className={classes.content}>
        <Typography className={classes.name}>{displayName}</Typography>
        {count > 0 && (
          <MiChip
            label={count}
            size="small"
            color="error"
            className={classes.chip}
          />
        )}
      </Box>
      <Box className={classes.bottomBar} style={{ backgroundColor: color }} />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey.accent}`,
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
    overflow: "hidden",
    cursor: "pointer",
    minWidth: 190,
    maxWidth: 190,
    userSelect: "none",
    transition: "all 0.2s ease-in-out",
  },
  selected: {
    backgroundColor: theme.palette.primary.light,
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 1.5),
    gap: theme.spacing(1),
  },
  name: {
    fontSize: theme.fontSize?.medium || 16,
    fontWeight: theme.fontWeight?.bold || 700,
    color: theme.palette.text.primary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 145,
  },
  chip: {
    height: 18,
    minWidth: 18,
    fontSize: 12,
    fontWeight: 600,
  },
  bottomBar: {
    height: 4,
    width: "100%",
  },
}));
